import * as THREE from 'three';

/**
 * Duvar çizgilerinin orta noktalarını tespit eder (Raycaster kullanarak - performanslı)
 * @param {THREE.Scene} scene - Three.js scene
 * @param {THREE.Camera} camera - Camera
 * @param {THREE.Vector2} mouseNDC - Mouse NDC koordinatları
 * @param {THREE.Vector3} mouseWorldPoint - Mouse'un dünya koordinatları
 * @param {number} threshold - Snap mesafesi (varsayılan: 15 birim)
 * @returns {Object|null} - { position, type: 'midpoint', segment: {start, end} } veya null
 */
export function getMidpointSnaps(scene, camera, mouseNDC, mouseWorldPoint, threshold = 15) {
    if (!scene || !camera || !mouseNDC || !mouseWorldPoint) return null;

    // Raycaster ile mouse altındaki objeleri bul
    const raycaster = new THREE.Raycaster();
    raycaster.params.Line.threshold = 3; // Line'lar için threshold
    raycaster.setFromCamera(mouseNDC, camera);

    // Sadece Line objelerini topluyoruz (performans için)
    const candidates = [];
    scene.traverse((obj) => {
        if (obj.type !== 'Line') return;
        if (!obj.geometry || !obj.geometry.attributes.position) return;
        
        // Wire ve marker'ları atla
        if (obj.userData?.type === 'wire' || 
            obj.userData?.type === 'wireSocket' ||
            obj.userData?.type === 'wireMachine' ||
            obj.userData?.role === 'wireMarker' ||
            obj.userData?.isOffsetPreview ||
            obj.userData?.isIntersectPreview) return;

        candidates.push(obj);
    });

    // Raycaster ile kesişen objeleri bul
    const intersects = raycaster.intersectObjects(candidates, false);
    
    if (intersects.length === 0) return null;

    // En yakın kesişen objeyi al
    const intersectedObj = intersects[0].object;
    const positions = intersectedObj.geometry.attributes.position;
    const vertexCount = positions.count;

    let closestMidpoint = null;
    let minDistance = threshold;

    // Sadece bu objenin segmentlerini kontrol et
    for (let i = 0; i < vertexCount - 1; i++) {
        const start = new THREE.Vector3().fromBufferAttribute(positions, i);
        const end = new THREE.Vector3().fromBufferAttribute(positions, i + 1);

        // Local to world
        intersectedObj.localToWorld(start);
        intersectedObj.localToWorld(end);

        // Segment uzunluğu çok kısa ise atla
        const segmentLength = start.distanceTo(end);
        if (segmentLength < 10) continue;

        // Orta nokta
        const midpoint = new THREE.Vector3().addVectors(start, end).multiplyScalar(0.5);

        // Mouse'a uzaklık
        const distance = midpoint.distanceTo(mouseWorldPoint);

        if (distance < minDistance) {
            minDistance = distance;
            closestMidpoint = {
                position: midpoint,
                type: 'midpoint',
                segment: { start, end },
                object: intersectedObj,
                uuid: intersectedObj.uuid
            };
        }
    }

    return closestMidpoint;
}
